import {
  useWSModal,
  useWSSnackbar,
  WSCard,
  WSEmptyState,
  WSInfoBox,
  WSList
} from "@wingspanhq/fe-component-library";
import { WSQueryCache } from "@ws-react-query";
import { useEffect } from "react";

import { queriesInsuranceMonitors } from "../../../../../v3/query/queriesInsuranceMonitors";
import { getRequirementsDependencies } from "../../../dependencies";
import { INSURANCE_MONITOR_EXPAND } from "../constants";
import { selectorIsInsuranceMonitorInProgress } from "../selectors/selectorIsInsuranceMonitorInProgress";

type Props = {
  onClose: () => void;
  insuranceCoverageMonitorId: string;
};

const ModalMatchingInProgress: React.FC<Props> = props => {
  const { openSnackbar } = useWSSnackbar();

  queriesInsuranceMonitors.getInsuranceMonitor.useQuery(
    {
      monitorId: props.insuranceCoverageMonitorId,
      expand: INSURANCE_MONITOR_EXPAND
    },
    {
      enabled: true,
      refetchInterval: response => {
        // keep polling while the monitor is still matching (Pending or
        // Monitoring); a terminal status means a match landed (Complete) or a
        // manually linked coverage failed validation (ForceMatched)
        if (
          response?.status &&
          !selectorIsInsuranceMonitorInProgress(response)
        ) {
          // TODO: issue with cache cause monitor status is updating synchronously and requirement status is updating asynchronously
          setTimeout(() => {
            getRequirementsDependencies().forEach(key =>
              WSQueryCache.invalidateQueries(key)
            );
            props.onClose();

            setTimeout(() => {
              getRequirementsDependencies().forEach(key =>
                WSQueryCache.invalidateQueries(key)
              );
            }, 3000);
          }, 3000);

          return false;
        }

        return 3000;
      }
    }
  );

  useEffect(() => {
    // TODO (v3-migration): no v3 field for shareInsurancePolicyTypes.
    openSnackbar({
      type: "warning",
      duration: 5000,
      message: "Sharing insurance policy types isn't available yet"
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <WSList gap="XL">
      <WSCard header="Policy matching">
        <WSList gap="L">
          <WSList gap="M">
            <WSInfoBox
              icon="loader"
              iconColor="blue400"
              theme="neutral"
              transparent
            >
              Please wait while we check your resources for matching policies...
            </WSInfoBox>

            <WSEmptyState
              bgColor="gray"
              orientation="horizontal"
              size="S"
              title={""}
              type="documents"
            />
            <WSInfoBox
              icon="time"
              iconColor="gray600"
              theme="neutral"
              transparent
            >
              Please wait while we check your resources for matching policies...
            </WSInfoBox>
          </WSList>
          <WSInfoBox theme="neutral">
            Do not close the pop-up while we checking your resources. If you
            close and exit out before any matches are found you can restart the
            process again.
          </WSInfoBox>
        </WSList>
      </WSCard>
    </WSList>
  );
};

export const useModalMatchingInProgress = () =>
  useWSModal(ModalMatchingInProgress, {
    title: "Policy matching",
    size: "M"
  });
